/* 
--------- Testing files ---------

1. /src/pages/menu/TestButton
2. /src/pages/menu <TestButton>
3. /src/pages/Testing
4. /src/PageRoutes <Testing>

*/

import { useEffect } from 'react'
import { View, Text, Pressable } from 'react-native'
import { useNavigate } from 'react-router-dom'
import PageWrapper from '../../components/PageWrapper'
import {
  GameHints,
  GamePasses,
  useGameContext,
} from '../../context/GameContext'
import { questions } from '../../data/contents'
import { useLocalStorage } from 'react-use'
import { resetAll } from '../../utils/resetFunctions'

// import './loader.css'

// ref: https://projects.lukehaas.me/css-loaders/

const stages = [
  { id: 1, name: `Stage1`, sub: [1] },
  { id: 2, name: `Stage2`, sub: [2] },
  { id: 3, name: `Stage3`, sub: [3] },
  { id: 4, name: `Stage4`, sub: [4] },
  { id: 5, name: `Stage5`, sub: [5] },
  { id: 6, name: `Stage6`, sub: [6] },
]

const stageIds = stages.map(o => o.id)
const stageSubIds = stages.map(o => o.sub).flat()

function Testing() {
  const navigate = useNavigate()
  const [, , remove] = useLocalStorage<{
    passes: GamePasses
    hints: GameHints
    role: string
  } | null>('loveproducer', null)

  const {
    updatePasses,
    updateHints,
    passes,
    hints,
    updateRole,
    updateSelectRole,
    updateVideo,
  } = useGameContext()

  const onResetHints = () =>
    updateHints(draft => {
      stageIds.forEach(subId => {
        delete draft[`stage${subId}`]
      })
    })

  const onResetRole = (role: string) => updateRole(() => role)

  const onResetAll = () => {
    resetAll({
      remove,
      updatePasses,
      updateHints,
      updateRole,
      updateSelectRole,
      updateVideo,
    })
    alert('Reset Successfully')
    navigate('/')
  }

  const hintsOpened = JSON.stringify(hints).includes('hint')
  const onControlHints = () => {
    const hintsNum = Object.values(questions).map(arr => arr.length)

    if (JSON.stringify(hints).includes('hint')) {
      onResetHints()
      updateHints(draft => {
        draft.stage1 = {}
        draft.stage2 = {}
        draft.stage3 = {}
        draft.stage4 = {}
        draft.stage5 = {}
        draft.stage6 = {}
      })
    } else {
      hintsNum.forEach((n, i) => {
        const obj: Record<string, boolean> = {}
        Array.from({ length: n }, (_, ii) => ii + 1).forEach(e => {
          obj[`hint${e}`] = true
        })

        updateHints(draft => {
          draft[`stage${i}`] = obj
        })
      })
    }
  }

  const onResetStage = (subs: number[]) => {
    const isPass = passes[`stage${subs[0]}`]

    subs.forEach(i => {
      updatePasses(draft => {
        draft[`stage${i}`] = isPass ? false : true
      })
    })
  }

  const allPassed = !Object.values(passes).includes(false)
  const onPassAll = () =>
    stageSubIds.forEach(i => {
      updatePasses(draft => {
        draft[`stage${i}`] = true
      })
    })

  const onNav = (stageId: number) => {
    navigate(`/stage${stageId}`)
  }

  const onNavMenu = () => {
    navigate('/main', { replace: true })
  }

  useEffect(() => {
    console.log('testing page')
  }, [])

  return (
    <PageWrapper
      id="test-wrapper"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'relative',
      }}
    >
      <View style={{ flexDirection: 'row' }}>
        <button
          style={{ backgroundColor: 'red', color: '#fff' }}
          onClick={onResetAll}
        >
          Reset
        </button>

        <button
          style={{
            backgroundColor: hintsOpened ? '#ffc2c2' : '#8892b3',
            color: hintsOpened ? '#444' : '#fff',
          }}
          onClick={onControlHints}
        >
          {hintsOpened ? 'Reset' : 'Open'} Hints
        </button>

        <button
          style={{ backgroundColor: '#58b368', color: '#fff' }}
          onClick={onNavMenu}
        >
          /menu
        </button>
      </View>

      <br />

      <View style={{ flexDirection: 'row' }}>
        {stages.map((obj, idx) => {
          const { id: stageId, name } = obj
          return (
            <button
              key={idx}
              style={{ backgroundColor: 'coral', color: 'white' }}
              onClick={() => onNav(stageId)}
            >
              {name}
            </button>
          )
        })}
      </View>

      <br />

      <View
        style={{
          width: '70%',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-evenly',
        }}
      >
        {stages.map((o, idx) => {
          const { id, sub } = o
          const isPass = passes[`stage${sub[0]}`]
          const bgc = isPass ? '#454d66' : '#309975'

          return (
            <button
              key={idx}
              style={{ backgroundColor: bgc, color: 'white' }}
              onClick={() => onResetStage(sub)}
            >
              {id}
            </button>
          )
        })}

        <button
          style={{
            backgroundColor: allPassed ? '#454d66' : '#309975',
            color: 'white',
          }}
          onClick={onPassAll}
        >
          {allPassed ? `-` : `all`}
        </button>
      </View>

      <br />
      <View style={{ flexDirection: 'row' }}>
        {['a', 'b', 'c', 'd', 'e'].map((obj, idx) => {
          return (
            <button
              key={idx}
              style={{ backgroundColor: '#49f', color: 'white' }}
              onClick={() => onResetRole(obj)}
            >
              role {obj}
            </button>
          )
        })}
      </View>
      {/* <View style={{ flexDirection: 'row' }}>
        {stages.map((obj, idx) => {
          const { id: stageId, name } = obj
          return (
            <button
              key={idx}
              style={{ backgroundColor: '#49f', color: 'white' }}
              onClick={() => onNavHints(stageId)}
            >
              Hints {stageId}
            </button>
          )
        })}
      </View> */}

      <br />

      <Pressable
        style={{ position: 'absolute', top: 50, left: 10 }}
        onPress={onNavMenu}
      >
        <Text
          style={{
            backgroundColor: 'grey',
            color: 'black',
            paddingHorizontal: 20,
            paddingVertical: 10,
            borderRadius: 5,
          }}
        >
          Back
        </Text>
      </Pressable>

      {/* @ts-ignore */}
      <style jsx="true">{`
        #test-wrapper {
        }

        #test-wrapper button {
          padding: 12px;
          min-width: 60px;
          border: #fff5 1px solid;
          margin: 2px;
        }
      `}</style>

      {/* {images} */}
    </PageWrapper>
  )
}

export default Testing
